import { render, staticRenderFns } from "./ActionLogAds.vue?vue&type=template&id=e97a2bd4"
import script from "./ActionLogAds.vue?vue&type=script&lang=js"
export * from "./ActionLogAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports